<svg
  [ngStyle]="styleList"
  [attr.width]="size"
  [attr.height]="size"
  viewBox="0 0 64 64"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect
    x="1.5"
    y="1.5"
    width="61"
    height="61"
    [attr.rx]="rx"
    fill="url(#paint0_linear_1102_1914)"
    stroke="#FEFEFE"
    stroke-width="3"
  />
  <path
    d="M20.7675 34.3777C16.7948 28.4483 18.1686 20.4634 23.8996 16.1866C28.6997 12.6045 35.3003 12.6045 40.1004 16.1866C45.8314 20.4634 47.2052 28.4483 43.2325 34.3777L32.6689 50.1443C32.3511 50.6186 31.6489 50.6186 31.3311 50.1443L20.7675 34.3777Z"
    fill="url(#paint1_linear_1102_1914)"
    stroke="url(#paint2_linear_1102_1914)"
  />
  <circle
    cx="32"
    cy="27"
    r="4"
    fill="white"
  />
  <defs>
    <linearGradient
      id="paint0_linear_1102_1914"
      x1="37.5"
      y1="64.0004"
      x2="-64.6232"
      y2="47.3419"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="white" />
      <stop
        offset="1"
        stop-color="#EBECF7"
      />
    </linearGradient>
    <linearGradient
      id="paint1_linear_1102_1914"
      x1="32"
      y1="13"
      x2="-5.07055"
      y2="23.6501"
      gradientUnits="userSpaceOnUse"
    >
      <stop />
      <stop
        offset="1"
        stop-color="white"
      />
    </linearGradient>
    <linearGradient
      id="paint2_linear_1102_1914"
      x1="41.2647"
      y1="10.0769"
      x2="22.9466"
      y2="22.5715"
      gradientUnits="userSpaceOnUse"
    >
      <stop
        stop-color="white"
        stop-opacity="0"
      />
      <stop
        offset="0.428115"
        stop-color="white"
        stop-opacity="0.81428"
      />
      <stop
        offset="1"
        stop-color="white"
        stop-opacity="0"
      />
    </linearGradient>
  </defs>
</svg>
